export default __webpack_public_path__ + "static/media/ic_sync.f5537e09.svg";